import { render, staticRenderFns } from "./dcp-changelog-2.2.0.md?vue&type=template&id=1f0a3e8c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports